import styled, { css } from 'styled-components'
import { Variables } from '../styles/Variables'
import media from 'css-in-js-media'
import Icon from './Icon'

export const Button_StylePrimary = css`
    background-color: transparent;
    color: ${Variables.color.pazola};
    border-color: ${Variables.color.pazola};
    &:before {
        border-color: ${Variables.color.pazola};
    }
    :hover {
        color: ${Variables.color.white};
        border-color: ${Variables.color.pazolaGold};
        background-color: ${Variables.color.pazolaGold};
        &::before {
            border-color: ${Variables.color.white};
        }
    }
`

export const Button_StyleSecondary = css`
    background-color: ${Variables.color.warmGrey};
    color: ${Variables.color.cocoa};
    :hover {
        background-color: black;
        color: white;
    }
`

export const StyledButton = styled.button`
    display: inline-block;
    height: 44px;
    background-color: ${Variables.color.white};
    border: 1px solid ${Variables.color.white};
    box-sizing: border-box;
    border-radius: 0;
    padding: 10.4px 35px 11.45;
    font-family: ${Variables.font.bodyBold};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    text-align: ${({ $textalign }) => $textalign || 'center'};
    letter-spacing: 0.1em;
    white-space: nowrap;
    cursor: pointer;
    outline: none;
    color: ${Variables.color.pazola};
    text-decoration: none;
    overflow: hidden;
    text-transform: uppercase;
    position: relative;

    transition: 0.1s background-color ease-out, 0.1s color ease-out;

    ${media('<desktop')} {
        height: 40px;
        font-size: 12px;
        line-height: 40px;
        width: 122px;
    }

    ${media('>=desktop')} {
        padding: 13px;
    }

    ${media('<tablet')} {
        padding: 0 17px;
    }

    &:before {
        content: ' ';
        position: absolute;
        top: 3px;
        left: 3px;
        right: 3px;
        bottom: 3px;
        border: 1px solid ${Variables.color.pazolaGold};
    }

    &:hover {
        ${media('>=desktop')} {
            background-color: ${Variables.color.pazolaGold};
            color: ${Variables.color.white};
            border-color: ${Variables.color.pazolaGold};

            &::before {
                border: 1px solid ${Variables.color.white};
            }
        }
    }

    ${({ $fluid }) =>
        $fluid &&
        css`
            display: flex;
            justify-content: space-between;
            width: 100%;
        `}

    ${({ $secondary }) =>
        $secondary &&
        css`
            height: 44px;
            padding: 17px 92px;
            background-color: transparent;
            color: ${Variables.color.white};
            border-color: ${Variables.color.white};
            font-size: 14px;
            line-height: 17px;

            ${Icon} {
                transition: 0.4s transform cubic-bezier(0.3, 0.51, 0, 1.08);
            }

            ${media('<tablet')} {
                width: 209px;
                /* padding: 12px 20px; */
                height: 40px;
                font-size: 12px;
            }

            &:hover {
                background-color: ${Variables.color.white};
                color: ${Variables.color.pazola};
                border-color: ${Variables.color.pazolaGold};
                ${Icon} {
                    transform: translate(-10px, 0);
                }
                &:before {
                    border: 1px solid ${Variables.color.pazolaGold};
                }
            }

            &:before {
                border: 1px solid ${Variables.color.white};
            }
        `}

    ${({ $full }) =>
        $full &&
        css`
            width: 100%;
        `}

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
            ${Icon} {
                transform: translate(100px, 0);
            }
            &:hover {
                ${Icon} {
                    transform: translate(100px, 0);
                }
            }
        `}

    ${(props) =>
        props.isSticky &&
        css`
            ${media('<desktop')} {
                position: fixed;
                bottom: 0;
                left: 0;
                right: 0;
                height: 80px;
                padding-left: 40px;
                padding-right: 40px;
                align-items: center;
            }
        `}
`
